import SectionHeading from "@/components/feature/SectionHeading";
import FeatureGrid from "@/components/feature/FeatureGrid";
import { customReasons } from "@/mocks/criacao-sites";

export default function CustomReasons() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Projeto sob medida"
          badgeIcon="ri-equalizer-line"
          badgeTone="secondary"
          title="Seu negócio não é igual aos outros. Seu site também não deveria ser."
          description="Evite sites genéricos que parecem iguais aos de qualquer empresa. A NXHOST desenvolve projetos considerando o segmento, posicionamento, público e objetivos de cada negócio."
        />
        <div className="mt-12">
          <FeatureGrid items={customReasons} columns={3} accent="secondary" />
        </div>
      </div>
    </section>
  );
}